import { updateDocument } from '@lib/firebaseHandler';

const collection = 'categories';

export const updateOrderCollections = async collections => {
    for (let i = 0; i < collections.length; i++) {
        await updateDocument(collections[i], collection);
    }
};
